import { Chip, CircularProgress, FormControl, MenuItem, Select } from "@mui/material"
import * as React from "react"
import { AXIOS_API_INSTANCE, get_service_order_part_color } from "../../Constants"

import { send_authorized_request } from "../../Constants/cognito";
import { useSnackbar } from "notistack";
import { useTrackedUser } from "../UserState";
import { sort_custom_statuses } from "../../Utils/service";

export default function ServiceOrderPartStatusDropdown(
    {
        service_id,
        part,
        setServiceOrder,
        setServiceOrderSavingStep,
        updatedPartCallback,
        include_declined = true,
        include_installed = true
    }
) {
    const { enqueueSnackbar } = useSnackbar();
    const [my_user,] = useTrackedUser();
    const [savingPartStatus, setSavingPartStatus] = React.useState(false);
    var custom_statuses = sort_custom_statuses(my_user.client.service_order_parts_statuses)
    if (!include_declined) {
        custom_statuses = custom_statuses.filter((status) => !['DECLINED'].includes(my_user.client.service_order_parts_statuses[status].type))
    }
    if (!include_installed) {
        custom_statuses = custom_statuses.filter((status) => !['INSTALLED'].includes(my_user.client.service_order_parts_statuses[status].type))
    }

    const changePartStatus = (part_id) => (e) => {
        const edit_part = {
            serviceorderservice_id: service_id,
            part_id: part_id,
            status: e.target.value
        }
        const status_type = my_user.client.service_order_parts_statuses[e.target.value].type
        const installing = status_type === 'INSTALLED'
        if (['DECLINED'].includes(status_type)) {
            setServiceOrderSavingStep(1)
        } else {
            setSavingPartStatus(1)
        }
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.post(`serviceorders/${part.service_order_id}/${installing ? 'install_part' : 'change_part_status'}`, edit_part).then((new_serviceOrder) => {
                enqueueSnackbar('Successfully changed part status', { variant: 'success' })
                if (['DECLINED'].includes(status_type)) {
                    setServiceOrder(new_serviceOrder.data.data)
                    setServiceOrderSavingStep(0)
                } else {
                    const part = new_serviceOrder.data.data.service_order_services.find((x) => x.id === service_id).service_order_parts.find((x) => x.id === part_id)
                    updatedPartCallback(part)
                    setSavingPartStatus(0)
                }
            }).catch((error) => {
                console.log(error)
                if (['DECLINED'].includes(status_type)) {
                    setServiceOrderSavingStep(0)
                } else {
                    setSavingPartStatus(0)
                }
                enqueueSnackbar(`Failed to change part status <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
            })
        )
    }

    return (
        <FormControl variant="standard" fullWidth sx={{ height: '100%', width: '100%' }}>
            <Select
                id={`serviceorder-service-part-status-${part.id}`}
                value={part.status_name}
                fullWidth
                onChange={changePartStatus(part.id)}
                variant="standard"
                renderValue={(status) => (
                    savingPartStatus ?
                        <CircularProgress />
                        :
                        <Chip key={status} label={status} color={get_service_order_part_color(my_user.client.service_order_parts_statuses, status)} sx={{ ml: 1 }} />
                )}
                sx={{ height: '100%', width: '100%' }}
                disabled={savingPartStatus}
            >
                {custom_statuses.map((status) => (
                    <MenuItem key={status} value={status}>
                        <Chip label={status} color={get_service_order_part_color(my_user.client.service_order_parts_statuses, status)} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}